module.exports = __webpack_public_path__ + "static/img/iPhone6.4ce66bbf.png";